jQuery( $ => {
	/**
	 * Generic back button functionality.
	 */
	$( '.js-back-button' ).click( e => {
		e.preventDefault();
		// Equal to clicking the back button in the browser.
		window.history.back();
	} );
} );
